import { useLocation, useNavigate } from "react-router-dom";
import { OnboardingNavigationState } from "../types/onboardingData";

export function useOnboardingData() {
  const location = useLocation();
  const data = location.state as OnboardingNavigationState | undefined;

  // Validate required data is present
  const hasError = !data?.vehicleData || !data?.quoteData;
  const errorMessage = hasError
    ? "Missing required vehicle or quote data. Please start from the vehicle assignment step."
    : "";

  return { data, hasError, errorMessage };
}